export default {
      id: "error-page-usage",
      viewBox: "0 0 433 366",
      url: __webpack_public_path__ + "sprite.svg#error-page",
      toString: function () {
        return this.url;
      }
    }